module.exports = __webpack_public_path__ + "static/img/zhengqingsheng.b4434db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/zhengqingsheng.jpg
// module id = BLnQ
// module chunks = 0